import styled from 'styled-components';

const DivRight = styled.div`
	justify-content: flex-end;
	display: flex;
`;

interface Props {
	children: React.ReactElement;
}

export const Right: React.FC<Props> = ({ children }) => <DivRight>{children}</DivRight>;
